/* eslint-disable no-unused-vars */
/* eslint-disable indent */
/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Card, Row, Col, message, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import moment from "moment";
import {
    TableComponent
} from "../../../CommonComponents";
import "../../styles.scss";
import Heading from "../../../../../components/Heading";
import { ReportsService } from "../../../../../services/api/reports";
import { downloadAuditedShipmentsClickable } from "../../../../../utils/downloadUtils";
import { useRequestCancellation } from "../../../../../hooks/useRequestCancellation";
import { useNavigate, useLocation } from "react-router-dom";
import { showErrorMessage } from "../../../../../utils";

const TotalAuditedClickableReport = () => {
    // Global request cancellation hook
    const { createNewRequest, isLatestRequest } = useRequestCancellation();

    const [loading, setLoading] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`
    });
    const [reportData, setReportData] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();

    const fetchReport = async () => {
        const { signal, requestId } = createNewRequest("total-audited-clickable-report");

        setLoading(true);
        let shouldUpdateState = true;

        try {
            const formParams = location.state || {};
            const { operationDate, hubId, type } = formParams;



            if (!operationDate || !hubId) {
                // console.warn("Missing required params for report fetch:", { operationDate, hubId, type });
                setLoading(false);
                return;
            }

            setReportData([]);
            const params = {
                operationDate: operationDate,
                hubId: hubId,
                ...(type && { doctype: type }),
                page: (pagination.current - 1),
                size: pagination.pageSize
            };



            const response = await ReportsService.getAuditedShipmentsClickable(params, { signal });



            if (!response) {
                return;
            }

            const { data, count } = response;

            if (!isLatestRequest(requestId)) {
                shouldUpdateState = false;
            } else {
                setReportData(data || []);
                setPagination(prev => ({
                    ...prev,
                    total: count || 0,
                }));
            }
        } catch (error) {
            if (error.name === "AbortError") {
                return;
            }
            console.error("TotalAuditedClickableReport - Fetch Error:", error);
            if (shouldUpdateState && isLatestRequest(requestId)) {

                setReportData([]);
                setPagination(prev => ({
                    ...prev,
                    total: 0,
                }));
            }
        } finally {
            if (shouldUpdateState && isLatestRequest(requestId)) {
                setLoading(false);
            }
        }
    };


    // Fetch report data
    useEffect(() => {

        if (!location.state) return;
        const { operationDate, hubId, type } = location.state;
        if (!operationDate || !hubId) {
            console.warn("Effect skipped due to missing state:", location.state);
            return;
        }
        fetchReport();
        // eslint-disable-next-line
    }, [location.state, pagination.current, pagination.pageSize]);

    const handleTableChange = (paginationInfo) => {
        setPagination(prev => ({
            ...prev,
            current: paginationInfo.current,
            pageSize: paginationInfo.pageSize
        }));
    };

    const handleDownload = async () => {
        setDownloadLoading(true);
        try {
            const formParams = location.state || {};
            const { operationDate, hubId, type } = formParams;
            const downloadParams = {
                operationDate: operationDate,
                hubId: hubId,
                ...(type && { doctype: type })
            };

            await downloadAuditedShipmentsClickable(downloadParams);
            message.success("Report downloaded successfully");
        } catch (error) {
            console.error("Download error:", error);
            message.error("Failed to download report");
        } finally {
            setDownloadLoading(false);
        }
    };

    const handleBack = () => {
        navigate("/inscan-vs-audit-report");
    };

    const getTableColumns = () => {
        return [
            {
                title: "Inscan Date",
                dataIndex: "date",
                key: "date",
                sorter: true,
                width: 120,
            },
            {
                title: "AWB Number",
                dataIndex: "awbNumber",
                key: "awbNumber",
                sorter: true,
                width: 150,
                render: (text, record) => (
                    <span
                        style={{ color: "#1890ff", cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => {
                            if (text) {
                                const url = `/shipment-tracker?awb=${text}`;
                                window.open(url, "_blank");
                            }
                        }}
                    >
                        {text || "-"}
                    </span>
                )
            },

            {
                title: "Audit Machine",
                dataIndex: "auditMachine",
                key: "auditMachine",
                sorter: true,
                width: 150,
            },
            {
                title: "Inscan Hub Name",
                dataIndex: "inscanHubName",
                key: "inscanHubName",
                sorter: true,
                width: 200,
            },
            {
                title: "Document Type",
                dataIndex: "documentType",
                key: "documentType",
                sorter: true,
                width: 120,
                render: (text) => text?.toUpperCase() || "-"
            },
            {
                title: "Booked Weight",
                dataIndex: "bookedWeight",
                key: "bookedWeight",
                sorter: true,
                width: 120,
            },
            {
                title: "Audited Weight",
                dataIndex: "auditedWeight",
                key: "auditedWeight",
                sorter: true,
                width: 120,
            },
            {
                title: "Travel By",
                dataIndex: "travelBy",
                key: "travelBy",
                sorter: true,
                width: 120,
            }
        ];
    };

    return (
        <div className="report-container">
            <div style={{ backgroundColor: "white", padding: "8px 16px", borderRadius: "8px" }}>
                <Heading
                    title="Audited Shipments Report"
                    navigateTo="/inscan-vs-audit-report"
                    goBack={handleBack}
                >
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        loading={downloadLoading}
                        onClick={handleDownload}
                    >
                        Download Report
                    </Button>
                </Heading>
            </div>
            <TableComponent
                columns={getTableColumns()}
                dataSource={reportData}
                loading={loading}
                pagination={pagination}
                onChange={handleTableChange}
                rowKey={(record, index) => record.awbNumber || record.id || record.awb || index}
                style={{ marginTop: 32 }}
                scroll={{ x: 1500 }}
            />
        </div>
    );
};

export default TotalAuditedClickableReport;
